import * as yup from 'yup';

import { AddressFields } from '../types';

/**
 * Creates schema validatiors
 * @param {Array} requiredFields - collection of required fields
 * @returns {Yup.Schema} validation schema
 */
const createAddressValidationSchema = (requiredFields: string[] = []) => {
  const schema: {
    [key in keyof AddressFields]: yup.StringSchema;
  } = {
    address: yup.string(),
    address2: yup.string(),
    city: yup.string(),
    country: yup.string(),
    state: yup.string(),
    zip: yup.string(),
  };

  (requiredFields as Array<keyof AddressFields>).forEach((fieldName) => {
    if (schema[fieldName]) {
      schema[fieldName] = schema[fieldName].required('required');
    }
  });

  const schemaValidator = yup.object(schema);

  return schemaValidator;
};

export default createAddressValidationSchema;
